import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { BrandsState, ListBrands } from '../models'

import getAllBrandsExtraReducer from '../thunks/get-all.thunk'

/**
 * SET INITIAL BRANDS STATE
 */
const initialState: BrandsState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  brands: [],
  currentBrand: null,
}

const brandsSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    setCurrentBrandAction(state, action: PayloadAction<ListBrands>) {
      state.currentBrand = action.payload
    },
  },
  extraReducers: (builder) => {
    getAllBrandsExtraReducer(builder)
  },
})

export const BrandsActions = brandsSlice.actions

export const brandsSelector = ({ brands }: ApplicationState) => brands

export default brandsSlice
